import { render, staticRenderFns } from "./Year.vue?vue&type=template&id=b17e686a&"
import script from "./Year.vue?vue&type=script&lang=js&"
export * from "./Year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports